import _ from 'lodash'
import color from './colorThemes'

import config from '../../../config'

const { minZoom: mn, maxZoom: mx } = config.map

const base = {
  source: 'osm',
  'source-layer': 'places',
  type: 'symbol',
  layout: {
    'text-field': '{name}',
    'text-font': ['FiraSansCompressed-Bold'],
    'text-transform': 'uppercase',
    'text-letter-spacing': 0.1,
  },
  paint: {
    'text-color': color.placesLabel,
    'text-halo-color': color.halo,
    'text-halo-width': 2,
  },
}

const createLayer = (id, minzoom, maxzoom, stops) =>
  _.merge({}, base, {
    id,
    minzoom,
    maxzoom: maxzoom + 0.1,
    filter: ['==', 'type', id],
    layout: {
      'text-size': {
        base: 1,
        stops,
      },
    },
  })

export default [
  createLayer('city', mn, mn + 2, [[mn, 45], [mx, 45]]),
  createLayer('town', mn, mn + 2, [[mn, 35], [mx, 35]]),
  createLayer('village', mn + 1, mx, [[mn, 25], [mx, 25]]),
  createLayer('suburb', mn + 2, mx, [[mn + 2, 20], [mx, 60]]),
]
